import { initialState } from "./state"

export const setGenres = (state, payload) => {
  state.genres = payload
  state.isLoaded = true
}

export const setIsLoading = (state, payload) => {
  state.isLoading = payload
}

export const reset = (state) => {
  const s = initialState()

  Object.keys(s).forEach((key) => {
    state[key] = s[key]
  })
}
